import { render, staticRenderFns } from "./Textfield.vue?vue&type=template&id=13dea605&"
import script from "./Textfield.vue?vue&type=script&lang=js&"
export * from "./Textfield.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports